module.exports = __webpack_public_path__ + "img/IMG_2333.f9781162.jpg";